export const buildProductRoute = (
    slug: string,
    supplierId?: string | null
): string[] => {
    return supplierId ? ["/product", slug, supplierId] : ["/product", slug];
};
